import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TablerIconsModule } from 'angular-tabler-icons';
import {
  formatScheduledPaymentDate,
  OrderService,
  parseScheduledPaymentDateForInput,
} from 'src/app/entities/order';

export interface OrderFreezeDeadlineDialogData {
  orderId: string;
  freezeDeadlineAt?: string | null;
  orderLabel?: string | number | null;
}

export interface OrderFreezeDeadlineDialogResult {
  freezeDeadlineAt: string;
}

@Component({
  selector: 'app-order-freeze-deadline-dialog',
  standalone: true,
  templateUrl: './order-freeze-deadline-dialog.component.html',
  styleUrls: ['./order-freeze-deadline-dialog.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    TablerIconsModule,
  ],
})
export class OrderFreezeDeadlineDialogComponent implements OnInit {
  readonly dateControl = new FormControl<Date | null>(
    null,
    Validators.required,
  );
  saving = false;
  error = '';

  constructor(
    private readonly orderService: OrderService,
    private readonly dialogRef: MatDialogRef<
      OrderFreezeDeadlineDialogComponent,
      OrderFreezeDeadlineDialogResult
    >,
    @Inject(MAT_DIALOG_DATA) public data: OrderFreezeDeadlineDialogData,
  ) {}

  ngOnInit(): void {
    const current = parseScheduledPaymentDateForInput(
      this.data.freezeDeadlineAt,
    );
    if (current) {
      this.dateControl.setValue(current);
    }
  }

  close(): void {
    if (this.saving) {
      return;
    }
    this.dialogRef.close();
  }

  save(): void {
    const value = this.dateControl.value;
    if (!value || this.saving) {
      this.dateControl.markAsTouched();
      return;
    }
    const freezeDeadlineAt = formatScheduledPaymentDate(value);
    this.saving = true;
    this.error = '';
    this.orderService
      .updateOrderFreezeDeadline(this.data.orderId, freezeDeadlineAt)
      .subscribe({
        next: () => {
          this.saving = false;
          this.dialogRef.close({ freezeDeadlineAt });
        },
        error: () => {
          this.saving = false;
          this.error = 'No se pudo guardar la fecha.';
        },
      });
  }
}
